import store from "../store";
import router from "../router";

export default function (error) {

  if (
    error.code === "ERR_NETWORK" &&
    !error.config.url.includes(':9000') // Checks if the URL contains port 9000
  ) {
    router.push('/offline');
    return;
  }


  if (error.response && error.response.data && error.response.data.responseCode === 'LICENSE_EXPIRED') {
    cleanupModals(); // Ensure modals and overlays are cleared
    router.push('/settings/license');
    return Promise.reject(error);
  }

  switch (error.response.status) {
    case 404:
      return Promise.resolve(error.response)
    case 401:
      store.dispatch('auth/logout').then(() => {
        router.push('/login')
      })
      return Promise.reject(error)
    case 409:
      return Promise.reject(error)
    case 403:
      return Promise.reject(error)
  }

  return Promise.reject(error)
}

function cleanupModals() {
  // Close any modals
  const modals = document.querySelectorAll('.modal.show');
  modals.forEach((modal) => {
    modal.classList.remove('show');
    modal.style.display = 'none';
  });

  // Remove modal-related classes from the body
  document.body.classList.remove('modal-open');

  // Remove all modal backdrops
  const backdrops = document.querySelectorAll('.modal-backdrop');
  backdrops.forEach((backdrop) => backdrop.remove());
}



// WEBPACK FOOTER //
// ./src/interceptors/failure.js